import { buildRequestURL, getRESTParams, REMBLE_API_URL } from '.'

/**
 * Returns posts that match the search query
 * @param {String} search The query string to search for
 * @param {Number} perPage The number of results to return per page
 * @param {Number} page The page number to return
 * @param {String} subtype The post subtype to search for (e.g. 'daily_remble')
 * @returns A JSON array of posts
 */
const getSearchResults = (search, perPage = 100, page = 1, subtype = null) => {
  // Modify the query to remove URL breaking characters
  search = search.replace(/[^a-zA-Z0-9 ]/g, '')

  const url = buildRequestURL(`${REMBLE_API_URL}/lms/search`, {
    per_page: perPage,
    page,
    search,
    context: 'embed',
    subtype
  })

  return fetch(url, getRESTParams()).then(response => response.json())
}

/**
 * Returns a searh term and optionally performs a search for that term from a message
 * @returns A JSON object containing the search term and (optionally) search results
 */
const getTermOrSearchResults = (message, search = true) => {
  const url = buildRequestURL(`${REMBLE_API_URL}/chat/term`, {
    question: message,
    search
  })

  return fetch(url, getRESTParams()).then(response => response.json())
}

export { getSearchResults, getTermOrSearchResults }
